import { Box, Button, Text, Container, Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LogosTable from "../../components/table";
import Layout from "../layouts";
import { Link, useNavigate } from "react-router-dom";
import LogosTablePagination from "../../components/table/table-pagination";
import { usePaginator } from "chakra-paginator";
import LogosTableSearch from "../../components/table/table-search";
import ShortenLinkService from "../../services/shorten/shortenlink-service";

const ShortenScene = (): ReactElement => {
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [shortenLinks, setShortenLinks] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [totalLink, setTotalLink] = useState<number>(0);
    const { isOpen: isShowDownloadSalesReportDialog, onOpen: onShowDownloadSalesReportDialog, onClose: onCloseDownloadSalesReportDialog } = useDisclosure();
    const [searchKey, setSearchKey] = useState<string>("");

    const {
        pagesQuantity,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        offset
    } = usePaginator({
        total: totalLink,
        initialState: {
            pageSize: 20,
            currentPage: 1
        }
    });


    useEffect(() => {
        setIsLoading(true);
        let skipCount = ((currentPage - 1) * pageSize);

        ShortenLinkService.GetList(searchKey, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setShortenLinks(res.result.items);
                setTotalLink(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [tabIndex, currentPage]);

    const handleClickRow = (shortLink: any) => {
        navigate(`/shorturls/${shortLink.id}`);
    };

    const handlePageChange = (nextPage: number) => {
        setCurrentPage(nextPage);
    };

    const handleSearch = (searchKey: string) => {
        //setIsLoading(true);
        let skipCount = ((currentPage - 1) * pageSize);

        ShortenLinkService.GetList(searchKey, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setShortenLinks(res.result.items);
                setTotalLink(res.result.totalCount);
            }
        }).finally(() => {
            //setIsLoading(false);
        });
    };

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Short Urls</Heading>
                </Box>
                <Flex mt={3}>
                    <Button onClick={() => navigate('/shorturls/new')}>Buat Url Baru</Button>
                </Flex>
                <Box mt={6}>
                    <LogosTableSearch handleSearch={handleSearch} />
                    <LogosTable
                        headers={[{ label: 'Name' }, { label: 'Back Half' }, { label: 'Long Url' }, { label: 'Visited', isNumeric: true }, { label: 'Created' }, { label: 'Status' }]}
                        rows={[{ propertyName: 'name', baseUrl: '/shorturls/' },
                        { propertyName: 'backHalf' },
                        {
                            propertyName: 'longUrl', render: (item: any) => {
                                return <Link title={item.longUrl} to={item.longUrl}>{item.longUrl.length > 50 ? `${item.longUrl.slice(0, 50)}...` : item.longUrl}</Link>
                            }
                        },
                        { propertyName: 'visited', isNumeric: true },
                        { propertyName: 'creationTime', isDate: true },
                        {
                            propertyName: 'status', render: (item: any) => {
                                return <Text fontWeight={'bold'} color={item.status == 10 ? "green.600" : "red.500"}>{item.status == 10 ? "Aktif" : "Tidak Aktif"}</Text>
                            }
                        }]}
                        data={shortenLinks}
                        onRowClick={handleClickRow}
                    />
                    <LogosTablePagination currentPage={currentPage} pagesQuantity={pagesQuantity} handlePageChange={handlePageChange} />
                </Box>
            </Container>
        </Layout >
    );
};

export default ShortenScene;